import MDEditor from '@uiw/react-md-editor';

/** Texto do post (Markdown) no visual do portal — sempre claro, como o resto do Digital. */
export function MarkdownPublicacao({ conteudo }: { conteudo: string }) {
  return (
    <div data-color-mode="light">
      <MDEditor.Markdown
        source={conteudo}
        style={{ background: 'transparent', fontFamily: 'inherit', fontSize: '0.875rem', color: '#334155' }}
      />
    </div>
  );
}
